import React, {useEffect, useState} from "react";

import {data1 , data2, data3} from './CardForm/formStructure'
import {CreateItemIcon3} from '../../utils/allImgs'
import {getMainWidth , handelTitle} from '../../utils'
import SectionHeading from '../../components/SectionHeading'
import CardForm from './CardForm'
import CategoryCard from './CategoryCard'
import './CreateItem.css'
//import BreadcrumbSimple from "../../components/BreadcrumbSimple";
import PreSaleHeading from "../../components/PreSaleHeading";
import Breadcrumb from "../../components/Breadcrumb/index.jsx";
import { sessionStorageGet, sessionStorageSet } from '../../lib/window-shim';

/**
 * List Item container page.
 *
 * Form for listing an NFT item for sale or auction.
 * Pre-populates with item data from sessionStorage (sellItem).
 * Manages form state including:
 * - Listing type (auction vs fixed price)
 * - Price, reserve, duration, etc.
 * Persists form fields to sessionStorage for recovery.
 * Uses CardForm for the main form and CategoryCard for settings.
 *
 * @module containers/ListItem
 * @category Containers
 * @returns {React.ReactElement} Rendered list item form page
 */
const ListItemContainer = () => {
  // Initialize state safely from sessionStorage.
  // This runs only once on the initial render.
  const [sellItemData, setSellItemData] = useState(() => {
    const savedItem = sessionStorageGet("sellItem");
    return savedItem ? JSON.parse(savedItem) : null;
  });

  const [formFields, setFormFields] = useState(() => {
    const savedFields = sessionStorageGet("formFields");
    // Initialize with data3 if nothing is saved.
    return savedFields ? JSON.parse(savedFields) : data3;
  });

  // State to control the visibility of the end time section.
  // `true` means it's an auction and should show end time.
  const [isAuction, setIsAuction] = useState(true);

  useEffect(() => {
    handelTitle('List an Item')
    getMainWidth()
    window.scroll(0, 0);
  }, []);

  // Persist formFields to sessionStorage whenever it changes.
  useEffect(() => {
    sessionStorageSet("formFields", JSON.stringify(formFields));
  }, [formFields]);

  return (
    <>
      <main className="main-content mt-1 border-radius-lg">
        <Breadcrumb text1='List Item' text2={sellItemData?.meta?.name}/>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-8">
              <PreSaleHeading id="abd"
                              img={sellItemData?.img}
                              text={`List Item "${sellItemData?.meta?.name}"`}
                              title='List an item for sale or auction'
              />
              <div className="col-12 mb-30">
                <div className="card card-purple z-index-0">
                  {/* Pass the state down as a prop */}
                  <CardForm data={formFields} showEnd={isAuction} media={sellItemData?.img}/>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="col-12">
                <SectionHeading
                                img={CreateItemIcon3}
                                text='Item Settings'
                                title='Item Settings'
                />
                {/* Pass the state setter function down to the child */}
                <CategoryCard data1={data1} data2={data2} setIsAuction={setIsAuction} />
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default ListItemContainer;
